//
import { createSelector, createStructuredSelector } from "reselect"
import { selectNoResultsType } from "shared/profiles/assignment/selectors"

export const selectListSlice = (state) => state.listAdder
export const selectDatumId = (state, props) => props.datumId
export const selectModel = (state, props) => props.model

export const selectList = createSelector(selectListSlice, selectModel, selectDatumId, (slice, model, datumId) => {
    const lists = slice.get(String(model) + String(datumId))
    return lists ? lists.toJS() : []
})

export const selectLoading = createSelector(selectListSlice, (slice) => slice.get("loading"))

export const selectProjects = createSelector(selectList, (lists) => {
    // get unique projects
    const projects = [...new Set(lists.map((list) => list.project))]
    // transform projects
    return projects.map((project) => {
        const projObj = {}
        const listsForProject = lists.filter((list) => list.project === project)
        // grabbing name here so we dont have to make a separate request for projects
        projObj.name = listsForProject[0]._extra && listsForProject[0]._extra.project_name
        projObj.id = project
        // transform lists how SelectedObjects expects it (with self as a reference to original list for our ac)
        projObj.lists = listsForProject.map((list) => ({
            self: list,
            id: list.id,
            text: list.name,
            locked: list.locked,
            styling: "blue-tag-1",
        }))
        return projObj
    })
})

export const selectFormattedValues = createSelector(selectProjects, (projects) => {
    const values = []
    projects.forEach((project) => {
        values.push({
            displayText: project.name,
            cannotRemove: true,
            ...project,
        })
        if (project.lists && project.lists.length) {
            project.lists.forEach((list) => {
                values.push({
                    displayText: `${list.text} (${project.name})`,
                    cannotClick: true,
                    ...list,
                })
            })
        }
    })
    return values
})

export const listAdderConnection = createStructuredSelector({
    formattedValues: selectFormattedValues,
    lists: selectList,
    loading: selectLoading,
    projects: selectProjects,
    noResultsType: selectNoResultsType,
})
